module.exports = __webpack_public_path__ + "static/media/erge.fcf4beee.jpg";